import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "swiper/css";
const teamMembers = [
  { name: "SENETH", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/seneth.jpg" },
  { name: "SAWANI", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/sawani.jpg" },
  { name: "SAMEERA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/sameera.jpg" },
  { name: "SHANTHA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/shantha.jpg" },
  { name: "THILAK", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/thilak.jpg" },
  { name: "SAMANTHI", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/samanthi.jpg" },
  { name: "SAMANTHA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/samantha.jpg" },
  { name: "RAJIN", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/rajin.jpg" },
  { name: "NADEEKA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/nadeeka.jpg" },
  { name: "SENA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/sena.jpg" },
  { name: "NIMAL", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/nimal.jpg" },
  { name: "MANISHIA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/manishia.jpg" },
  { name: "MADUSHA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/madusha.jpg" },
  { name: "MADAWA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/madawa.jpg" },
  { name: "LAKRAJ", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/lakraj.jpg" },
  { name: "LAHIRU", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/lahiru.jpg" },
  { name: "KUMUDUNI", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/kumuduni.jpg" },
  { name: "JEEWAN", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/jeewan.jpg" },
  { name: "ISTAQ", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/istaq.jpg" },
  { name: "DIMUTHU", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/dimuthu.jpg" },
  { name: "DILUP", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/dilup.jpg" },
  { name: "DARSHANA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/darshana.jpg" },
  { name: "ANUSHA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/anusha.jpg" },
  { name: "CHEF NISHANTHA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/chef-nishantha.jpg" },
  { name: "KUMARA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/kumara.jpg" },
  { name: "CHANDANA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/chandana.jpg" },
  { name: "CHAMPIKA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/champika.jpg" },
  { name: "ARUNA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/aruna.jpg" },
  { name: "AKILA", image: "https://hiru-ayurveda-resorts.com/wp-content/uploads/2017/10/akila.jpg" }
];
const MudraTeam = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto flex flex-col px-4 sm:px-6 lg:px-8">
                <p className="order-1 text-center font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                    Die Gastfreundschaft von Hiru Mudra
                </p>

                {
    /* 2. Das Team von Hiru Mudra */
  }
                <h2 className="order-2 mt-5 text-center font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                    Das Team von Hiru Mudra
                </h2>

                {
    /* Images (mobile: 3rd / desktop: 4th) */
  }
                <div className="order-3 relative mx-auto mt-12 w-full max-w-7xl px-10 sm:px-12 lg:order-4 lg:px-14">
                    <Swiper
    modules={[Autoplay, Navigation]}
    navigation={{ nextEl: ".mudra-team-next", prevEl: ".mudra-team-prev" }}
    autoplay={{ delay: 3500, disableOnInteraction: false }}
    loop
    speed={700}
    spaceBetween={16}
    slidesPerView={1}
    breakpoints={{
      640: { slidesPerView: 2, spaceBetween: 20 },
      1024: { slidesPerView: 3, spaceBetween: 24 }
    }}
  >
                        {teamMembers.map((member) => <SwiperSlide key={member.name}>
                                <article className="group overflow-hidden rounded-[20px] bg-[#fbfaf7] shadow-[0_18px_45px_rgba(16,38,26,0.1)]">
                                    <div className="relative aspect-[3/4] overflow-hidden bg-[#f3eee7]">
                                        <img
    src={member.image}
    alt={`${member.name} aus dem Team von Hiru Mudra`}
    className="object-cover transition-transform duration-700 group-hover:scale-105"
    loading="lazy" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} />
                                        <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/80 via-transparent to-transparent" />
                                        <h3 className="absolute inset-x-3 bottom-4 text-center font-mulish text-sm font-semibold tracking-[0.2em] text-white sm:text-base">
                                            {member.name}
                                        </h3>
                                    </div>
                                </article>
                            </SwiperSlide>)}
                    </Swiper>

                    <button
    type="button"
    className="mudra-team-prev absolute left-0 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white text-[#1f4d3c] shadow-lg transition hover:bg-[#F28600] hover:text-white"
    aria-label="Vorheriges Teammitglied"
    title="Vorheriges Teammitglied"
  >
                        <FiChevronLeft className="h-5 w-5" aria-hidden="true" />
                    </button>
                    <button
    type="button"
    className="mudra-team-next absolute right-0 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white text-[#1f4d3c] shadow-lg transition hover:bg-[#F28600] hover:text-white"
    aria-label="Nächstes Teammitglied"
    title="Nächstes Teammitglied"
  >
                        <FiChevronRight className="h-5 w-5" aria-hidden="true" />
                    </button>
                </div>

                {
    /* Paragraphs (mobile: 4th / desktop: 3rd) */
  }
                <div className="order-4 mx-auto mt-8 max-w-4xl text-center lg:order-3 lg:mt-6">
                    <p className="font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                        Der Stolz von Hiru Mudra ist das engagierte Team, das Gäste wie Familienmitglieder herzlich empfängt. Von erfahrenen Ayurveda-Ärzten über geschulte Therapeuten und Köche, die mit Herz und Hingabe kochen, bis hin zu Hauspersonal und Gärtnern, die Ihren Aufenthalt angenehm gestalten.
                    </p>
                    <p className="mt-5 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                        Wir gehen über den bloßen Service hinaus und begleiten Sie auf Ihrer Reise, damit Sie sich körperlich und geistig tief entspannen und zu sich selbst zurückfinden. Unser freundliches Team erwartet Sie mit einem Lächeln an der wunderschönen Küste von Maggona.
                    </p>
                </div>
            </div>
        </section>;
};
export default MudraTeam;
